export const appBoxDataHooks = {
  container: 'app-box-container',
};
